export const Book = () => {
  return (
    <svg viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 15C1 14.4696 1.19754 13.9609 1.54917 13.5858C1.90081 13.2107 2.37772 13 2.875 13H13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.875 1H13V17H2.875C2.37772 17 1.90081 16.7893 1.54917 16.4142C1.19754 16.0391 1 15.5304 1 15V3C1 2.46957 1.19754 1.96086 1.54917 1.58579C1.90081 1.21071 2.37772 1 2.875 1V1Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 4H9" stroke="currentColor" strokeLinecap="round" />
      <path d="M5 6H9" stroke="currentColor" strokeLinecap="round" />
    </svg>
  )
}
